import React, { useState } from 'react';
import { Center, Box, Circle, Pressable, Text, useTheme } from 'native-base';
import { TextInput } from 'react-native';
import { Z_INDEX } from '../Constants';
import { useAuthState } from '../../context/auth';
import { useEnvState } from '../../context/env';
import { topicsAPI } from '../../context/topics';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { faPaperPlaneTop } from '@fortawesome/pro-solid-svg-icons';
import { dmNotAllowedAlert, sentenceJoinUserNames } from '../utils/helpers';
import { LANGUAGES, RAW_MIN_LENGTH } from '../Constants';
import { useEditPostDispatch } from '../../context/edit';
const CreateMessageBox = ({
  topicId,
  topicTitle,
  users,
  trackForum,
  setPrivateMessageId
}) => {
  const theme = useTheme(),
    {
      colors
    } = theme;
  const isNewDirectMessage = !topicId ? true : false;
  const [raw, setRaw] = useState('');
  const authState = useAuthState();
  const envState = useEnvState();
  const [inputHeight, setInputHeight] = useState(54);
  const editPostDispatch = useEditPostDispatch();
  const handleContentSizeChange = (contentWidth, contentHeight) => {
    const newHeight = Math.max(54, contentHeight);
    if (newHeight !== inputHeight) {
      setInputHeight(Math.max(54, contentHeight));
    }
  };
  const handleSendPrivateMessage = async () => {
    if (raw.length < RAW_MIN_LENGTH) {
      return;
    }
    if (users.some(u => !u.can_send_private_message_to_user)) {
      dmNotAllowedAlert();
    } else {
      try {
        let data = {};
        if (isNewDirectMessage) {
          data = {
            title: topicTitle,
            raw,
            archetype: 'private_message',
            target_recipients: users.map(u => u.username).join(','),
            tags: [envState.product]
          };
        } else {
          data = {
            raw,
            topic_id: topicId
          };
        }
        const response = await topicsAPI.createTopicReply(envState.base_url, authState.api_key, data);
        setRaw('');
        trackForum && trackForum({
          interaction: 'private_message'
        });
        setPrivateMessageId && setPrivateMessageId(response.topic_id);
        editPostDispatch({
          type: 'SET_POST_UPDATED',
          payload: {
            topicId: response.topic_id
          }
        });
        return response;
      } catch (err) {
        console.log('Error while sending private message');
        return err;
      }
    }
  };
  return /*#__PURE__*/React.createElement(Center, {
    bottom: 0,
    w: '100%',
    Z_INDEX: Z_INDEX.top
  }, /*#__PURE__*/React.createElement(Text, null, "Please enter at least ", RAW_MIN_LENGTH, " characters."), /*#__PURE__*/React.createElement(Box, {
    w: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    my: 4
  }, /*#__PURE__*/React.createElement(TextInput, {
    style: {
      width: 'calc(100% - 50px)',
      minHeight: 54,
      maxHeight: 300,
      height: inputHeight,
      borderColor: colors.createMessageBox.border,
      borderWidth: 1,
      overflowY: 'scroll',
      padding: 10,
      paddingTop: 16
    },
    placeholder: `${isNewDirectMessage ? LANGUAGES.PLACEHOLDERS.NEW_TOPIC : LANGUAGES.PLACEHOLDERS.SEND_PM} ${sentenceJoinUserNames({
      authState,
      users,
      includeSelf: false
    })}...`,
    value: raw,
    onChangeText: t => setRaw(t),
    multiline: true,
    onContentSizeChange: e => handleContentSizeChange(e.nativeEvent.contentSize.width, e.nativeEvent.contentSize.height)
  }), /*#__PURE__*/React.createElement(Box, {
    w: "40px"
  }, /*#__PURE__*/React.createElement(Pressable, {
    disabled: raw.length < RAW_MIN_LENGTH,
    justifyContent: 'center',
    alignItems: 'center',
    onPress: handleSendPrivateMessage
  }, /*#__PURE__*/React.createElement(Circle, {
    size: 10,
    bg: colors.createMessageBox.circle
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faPaperPlaneTop,
    color: colors.createMessageBox.icon
  }))))), /*#__PURE__*/React.createElement(Text, null, "If you encounter any issues or have concerns, please email us at\xA0", /*#__PURE__*/React.createElement("a", {
    href: "mailto:support@foodrevolution.org"
  }, "support@foodrevolution.org")));
};
export default CreateMessageBox;
//# sourceMappingURL=CreateMessageBox.js.map